import { apiClient } from './api';
import type { CalendarData } from './types';

export class CalendarService {
  static async getCalendarData(dateFrom: string, dateTo: string): Promise<CalendarData> {
    const response = await apiClient.get<CalendarData>(
      `/api/calendar?dateFrom=${dateFrom}&dateTo=${dateTo}`
    );
    return response.data;
  }
}

export default CalendarService;
